import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import Select from 'components/Inputs/Select/Select';
import localeUtils from 'utils/LanguageLocale';
import UIUtils from 'utils/UI';

const { COUNTRIES } = localeUtils;
const { isSMUI } = UIUtils;

function CountrySelect({
    country,
    countryInvalid = false,
    countryList = [],
    isBillingAddress = false,
    disableCountryList = false,
    localization = {},
    onChange,
    countrySelectRef
}) {
    const { caName, usName, countryText } = localization;
    const isUS = localeUtils.isUS();
    const isCanada = country === COUNTRIES.CA;

    // TODO: Update this when an improvement story comes on later sprint
    let displayCountryList = countryList;

    if (isSMUI() && !isBillingAddress && (isUS || isCanada)) {
        const mobileCountryList = [
            {
                countryCode: 'CA',
                countryLongName: caName
            },
            {
                countryCode: 'US',
                countryLongName: usName
            }
        ];
        displayCountryList = mobileCountryList;
    }

    return (
        <Select
            name='country'
            label={countryText}
            autoComplete='country'
            value={country}
            invalid={countryInvalid}
            onChange={onChange}
            disabled={disableCountryList}
            ref={countrySelectRef}
        >
            {displayCountryList &&
                displayCountryList.length > 0 &&
                displayCountryList.map(countryItem => (
                    <option
                        key={countryItem.countryCode}
                        value={countryItem.countryCode}
                    >
                        {countryItem.countryLongName}
                    </option>
                ))}
        </Select>
    );
}

export default wrapFunctionalComponent(CountrySelect, 'CountrySelect');
